import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { DashboardContext } from "../../../../context/DashboardContext";
import { useNavigate } from "react-router-dom";
import style from './profile.module.css';

const Profile = () => {
  const { user } = useContext(AuthContext);
  const { profile, fetchDashboardData, loading } = useContext(DashboardContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.apikey) {
      fetchDashboardData(user.apikey);
      
    }
  }, [user]);

  if (loading) return <p>Loading profile...</p>;

  return (
    <div className={style.profileContainer}>
      <h2>PROFILES</h2>

      <table className={style.profileTable}>
        <thead>
          <tr>
            <th>Set as Default</th>
            <th>Name</th>
            <th>Address</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {profile ? (
            <tr>
              <td><input type="radio" name="defaultProfile" /></td>
              <td>{profile.name}</td>
              <td>{profile.address}</td>
              <td>
                <button 
                  className={style.editProfileBtn}
                  onClick={() => navigate('/UserProfile')}
                >
                  EDIT PROFILE
                </button>
              </td>
            </tr>
          ) : (
            <tr><td colSpan="4">No profile data found.</td></tr>
          )}
        </tbody>
      </table>

      <h2>RELATIVES</h2>

      <table className={style.profileTable}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Relation</th>
            <th>DOB</th>
            <th>MA</th>
          </tr>
        </thead>

        <tbody>
          {profile?.relatives?.length > 0 ? (
            profile.relatives.map((relative, index) => (
              <tr key={index}>
                <td>{relative.name}</td>
                <td>{relative.relation}</td>
                <td>{relative.dob}</td>
                <td>{relative.ma}</td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="4">No relatives data found.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Profile;
